import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import Aux from '../containers/AuxContainer'
import Background from '../assets/images/stock1.jpg'
import VideoPlaceholder from '../assets/images/video_placeholder.png'

import ProjectLinkUrlModal from '../components/modals/ProjectLinkUrlModal'


class PublicRegistrationDescription extends Component {

	state = { 
		showProjectLinkModal: false
	}

	componentWillUnMount() {
		
	}

	onOpenModal = () => {
			this.setState({ 
				showProjectLinkModal: true
			});
		}

	onCloseModal = () => {
			this.setState({ showProjectLinkModal: false });
		}

	render () {

		const style = {
			backgroundImage: `url(${Background})`,
			backgroundSize: 'cover'
		}

		const display = {
			display: 'none'
		}

		const h4 = {
			color: '#fff',
			textShadow: '0 0 5px #000'
		}
		const imageBackground = {
			textShadow: '0 0 30px #000'
		}

		const { project, company, location } = this.props

		const { showProjectLinkModal } = this.state;

		if (!project) {
			return ( <div>Loading</div>)
		}

		return (
			<Aux>
				<section className="gray-bg section public-registration landing-page" style={style}>
					<div className="row">
					<div className="small-12 small-centered column text-center">
						
						<div className="container">
							<div className="callout secondary small text-center background-none">
									<div>
									{ project ? <img src={project.cover_url} alt="" width="600" style={imageBackground} /> : '' }
									</div>
									<br/>
									
							</div>
						</div>

						<div className="container">
							<div className="callout secondary large background-black">
								
							  
							  <div className="small-12 medium-8 medium-centered column text-center">

							  <h4 style={h4}>{project.name}</h4>
							  <br/>
							  <p>{ project.description }</p>
							  	{
							  		// TODO: Hide this for now
							  		// <img src={VideoPlaceholder} alt=""/>
							  	}
							  </div>
							</div>
						</div>

					</div>
					</div>
				</section>


				<section className="section">
	 				<div className="row">
	 				<div className="small-12 small-centered column text-center">
	 					{
	 						!project.pre_registration ?
								<div>
									<p>SORRY THIS PROJECT IS NOW CLOSED</p>
									<Link to="/" className="button primary large" disabled={!project.pre_registration}
										onClick={(event) => event.preventDefault()}>Apply Now</Link>
								</div> :
								<Link className="button primary large"
									to={{ 
										pathname: '/artist/login', 
										search: location.search,
										state: {
											client: { 
												...company,
												logo_url: company.logo_url
											},
											projectId: project
										}
									}}>Apply Now</Link>
						}
					</div>
					</div>
				</section>
				
				
			</Aux>
		)
	}

	// render() {
	// 	const { match, location, project, roles, companies } = this.props
	// 	const projectLogo = project ? project.cover_url : '';

	// 	if (!project) {
	// 		return (
	// 			<div className="text-center">Loading..</div>
	// 		)
	// 	}

	// 	const style = {
	// 		backgroundImage: `url(${Background})`,
	// 		backgroundSize: 'cover'
	// 	}

	// 	const h4 = {
	// 		color: '#fff',
	// 		textShadow: '0 0 5px #000'
	// 	}
	// 	const imageBackground = {
	// 		textShadow: '0 0 30px #000'
	// 	}

	// 	return (
	// 		<Aux>

	// 			<section className="gray-bg section public-registration landing-page" style={style}>
	// 				<div className="row">
	// 				<div className="small-12 small-centered column text-center">
						
	// 					<div className="container">
	// 						<div className="callout secondary small text-center background-none">
	// 								<div>
	// 								{ projectLogo ? <img src={projectLogo} alt="" width="600" style={imageBackground} /> : '' }
	// 								</div>
	// 								<br/>
									
	// 						</div>
	// 					</div>

	// 					<div className="container">
	// 						<div className="callout secondary large background-black">
								
							  
	// 						  <div className="small-12 medium-8 medium-centered column text-center">

	// 						  <h4 style={h4}>{project.name}</h4>
	// 						  <br/>
	// 						  <p>{ project.description }</p>
	// 						  	{
	// 						  		// TODO: Hide this for now
	// 						  		// <img src={VideoPlaceholder} alt=""/>
	// 						  	}
	// 						  </div>
	// 						</div>
	// 					</div>

	// 					{
	// 					// TODO: Hide this for now
	// 					// <div className="container">
	// 					// 	<div className="callout secondary large background-black">
	// 					// 	  <h5>Conditions of Applying</h5>
	// 					// 	  <div dangerouslySetInnerHTML={{__html: project.checkin_condition}} />
	// 					// 	</div>
	// 					// </div>
	// 					}

	// 				</div>
	// 				</div>
	// 			</section>

	// 			<section className="section">
	// 				<div className="row">
	// 				<div className="small-12 small-centered column text-center">
	// 					{
	// 					/* TODO: uncomment this after all public registration settings works */
	// 					// <Link className="button primary" to={{ 
	// 					// 	pathname: `${match.path}/roles_selection`, 
	// 					// 	search: location.search
	// 					// }}>Proceed</Link>
	// 					}


	// 					<Link className="button primary large" 
	// 					to={{ 
	// 						pathname: '/artist/login', 
	// 						search: location.search,
	// 						state: {
	// 							client: { 
	// 								...companies[0],
	// 								logo_url: companies[0].logo.logo.url
	// 							},
	// 							projectId: project
	// 						}
	// 					}}>Apply Now</Link>


	// 				</div>
	// 				</div>
	// 			</section>
				
					
	// 		</Aux>
	// 	)
	// }
}


// const mapStateToProps = state => {
// 	return {
// 		...state.projects
// 	}
// }


const mapStateToProps = state => ({
	project: state.projects.project,
	company: state.projects.company
})

export default connect(mapStateToProps)(PublicRegistrationDescription)











// WEBPACK FOOTER //
// ./src/components/PublicRegistrationDescription.js